/**
 * Bun theme switching. The theme attribute lives on <html> so CSS variables
 * reach portal-rendered content (modals, menus) too. Only Bun components
 * read these variables, so flipping the theme never restyles legacy screens.
 */
const STORAGE_KEY = "bun-theme";

export function getBunTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function setBunTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  if (next === "dark") {
    document.documentElement.setAttribute("data-bun-theme", "dark");
  } else {
    document.documentElement.removeAttribute("data-bun-theme");
  }
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* storage unavailable (private mode) — theme still applies this session */
  }
  return next;
}

/** Apply the persisted theme. Call once from any Bun screen's mount. */
export function applyBunTheme() {
  return setBunTheme(getBunTheme());
}
